import { STATS } from "../../lib/portfolioData";
import { SectionHeader } from "./Reveal";

export const Milestones = () => (
  <section id="results" data-testid="results-section" className="relative py-24 sm:py-28 md:py-44 bg-[#0a1220]/40 border-y border-white/5 overflow-hidden">
    <div className="max-w-7xl mx-auto px-6 md:px-10">
      <SectionHeader chapter="03" overline="Career Milestones" title="Proven results, measured in revenue." />

      <div className="grid grid-cols-1 md:grid-cols-3 gap-10 sm:gap-8 md:gap-6 items-start">
        {STATS.map((s, i) => (
          <div
            key={s.label}
            data-testid={`stat-${i}`}
            className="relative py-4 md:py-6 md:border-l md:border-white/10 md:pl-8 md:first:border-l-0 md:first:pl-0"
          >
            <p
              data-testid={`stat-number-${i}`}
              className="font-display text-[3.25rem] sm:text-6xl md:text-7xl lg:text-8xl tracking-tighter leading-none whitespace-nowrap"
            >
              {s.value}
              <span className="text-accent">{s.suffix}</span>
            </p>
            <p className="mt-5 md:mt-6 text-lg font-medium">{s.label}</p>
            <p className="mt-2 text-sm text-[#94a3b8] max-w-xs">{s.sub}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
